import { useEffect, useState } from "react";

import { Switch, FormControlLabel } from "@mui/material";

import { request } from "@/Api";
import { store } from "@/sheet/bidStore";

export default function BidTemplatePublishingSwitch({
    field,
    toggleField,
    label,
    invertBoolean,
    disabled,
}) {
    const template = store.bid.bid_template;
    const [bidTemplate, setBidTemplate] = useState({});

    useEffect(() => {
        setBidTemplate(template);
    }, []);

    const updateBidTemplate = () => {
        request
            .patch(`/bid-templates/${template.id}`, {
                [field]: toggleField(bidTemplate[field]),
            })
            .then((response) => {
                setBidTemplate(response.data);
            });
    };

    if (!template) {
        return null;
    }

    return (
        <FormControlLabel
            label={label}
            control={
                <Switch
                    checked={
                        invertBoolean ? !bidTemplate[field] : bidTemplate[field]
                    }
                    onChange={updateBidTemplate}
                />
            }
            disabled={disabled}
        />
    );
}
